/* ============================================================
   Velá — Theme JS
   Vanilla, sin framework. Implementa:
   - Variant picker (chips)
   - Quantity buttons
   - Accordion (significado)
   - Cart drawer (open/close, fetch cart, render, remove line)
   - Sticky mobile (CSS-only; aquí solo cableamos el botón add)
   - Toast
   - Sort menu (collection)
   ============================================================ */

(function () {
  'use strict';

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    $$('[data-product-form]').forEach(initProductForm);
    initAccordion();
    initCartDrawer();
    initMobileMenu();
    initSortMenu();
    initCollectionFilters();
  }

  // ── Currency formatting ────────────────────────────────────
  function shopCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
  }

  function formatMoneyCents(cents) {
    const currency = shopCurrency();
    const locale = currency === 'USD' ? 'en-US' : 'es-MX';
    const value = (cents || 0) / 100;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  // ── Variant picker ─────────────────────────────────────────
  function initProductForm(form) {
    const variantsScript = $('[data-product-variants]', form);
    if (!variantsScript) return;

    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const variantIdInput = $('[data-variant-id]', form);
    const submitBtn      = $('[data-submit-btn]', form);
    const buyNowBtn      = $('[data-buy-now]', form);
    const priceTarget    = $('[data-price-mxn]', form.parentElement) || $('[data-price-mxn]');

    $$('.vchip', form).forEach(chip => {
      chip.addEventListener('click', () => {
        const group = chip.closest('.vgroup');
        $$('.vchip', group).forEach(c => {
          c.classList.remove('vchip-on');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('vchip-on');
        chip.setAttribute('aria-pressed', 'true');

        const labelValue = $('[data-vlabel-value]', group);
        if (labelValue) labelValue.textContent = '— ' + chip.dataset.label;

        // Select matching variant by all option values currently chosen
        const selected = $$('.vchip-on', form).map(c => c.dataset.value);
        const match = variants.find(v =>
          v.options.length === selected.length &&
          v.options.every((opt, i) => opt === selected[i])
        );
        if (!match) return;

        variantIdInput.value = match.id;
        if (priceTarget) priceTarget.textContent = formatMoneyCents(match.price);

        if (submitBtn) {
          if (match.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.labelAdd || 'Agregar al carrito';
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = submitBtn.dataset.labelSold || 'Agotado';
          }
        }
      });
    });

    // Quantity buttons
    const qtyInput = $('[data-qty-input]', form);
    if (qtyInput) {
      const minus = $('[data-qty-minus]', form);
      const plus  = $('[data-qty-plus]', form);
      if (minus) minus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      if (plus) plus.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    // Add to cart (fetch, no redirect)
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      submitBtn && (submitBtn.disabled = true);

      fetch(form.action, {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(r => r.json())
        .then(data => {
          if (data.status) {
            showToast(data.description || 'No se pudo agregar');
            return;
          }
          showToast('Añadido al carrito');
          refreshCart({ open: false });
        })
        .catch(() => showToast('Error de conexión'))
        .finally(() => { if (submitBtn) submitBtn.disabled = false; });
    });

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(r => r.json())
          .then(data => {
            if (data.status) { showToast(data.description || 'No se pudo agregar'); return; }
            refreshCart({ open: true });
          })
          .catch(() => showToast('Error de conexión'));
      });
    }
  }

  // ── Accordion (significado) ────────────────────────────────
  function initAccordion() {
    $$('[data-accordion-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = document.getElementById(btn.dataset.accordionToggle);
        if (!target) return;
        const open = target.classList.toggle('acc-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        const caret = $('[data-acc-caret]', btn);
        if (caret) caret.textContent = open ? '↑' : '›';
      });
    });
  }

  // ── Cart drawer ────────────────────────────────────────────
  // ── Menú móvil ───────────────────────────────────────────
  function initMobileMenu() {
    const drawer = $('[data-menu-drawer]');
    if (!drawer) return;
    const scrim  = $('[data-menu-scrim]');
    const burger = $('[data-menu-open]');

    function open() {
      drawer.classList.add('mnav-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('mnav-scrim-on');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('mnav-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('mnav-scrim-on');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-menu-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-menu-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('.mnav-link')) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('mnav-open')) close();
    });
  }

  function initCartDrawer() {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    const scrim  = $('[data-cart-scrim]');

    function open() {
      drawer.classList.add('cd-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('cd-scrim-on');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('cd-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('cd-scrim-on');
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); open(); return; }
      const closer = e.target.closest('[data-cart-close]');
      if (closer) { e.preventDefault(); close(); return; }
      const remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        const key = remove.dataset.cartRemove;
        changeLine(key, 0);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('cd-open')) close();
    });

    window.__velaCart = { open, close };
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then(r => r.json())
      .then(() => refreshCart({ open: false }))
      .catch(() => showToast('No se pudo actualizar'));
  }

  function refreshCart(opts) {
    const open = opts && opts.open;
    fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' }})
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const next = tmp.querySelector('[data-cart-drawer]');
        const current = $('[data-cart-drawer]');
        if (next && current) current.replaceWith(next);
        updateCartCount();
        if (open && window.__velaCart) window.__velaCart.open();
      })
      .catch(() => {});
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }})
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;
        $$('[data-cart-count]').forEach(el => {
          const prev = parseInt((el.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
          if (count > 0) {
            el.textContent = ' · ' + count;
            el.style.display = '';
            if (count !== prev) {
              el.classList.remove('cart-count-bump');
              void el.offsetWidth; // restart animation
              el.classList.add('cart-count-bump');
              setTimeout(() => el.classList.remove('cart-count-bump'), 420);
            }
          } else {
            el.textContent = '';
            el.style.display = 'none';
          }
        });
      })
      .catch(() => {});
  }

  // ── Toast ──────────────────────────────────────────────────
  let toastTimer = null;
  function showToast(message) {
    let toast = $('[data-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('data-toast', '');
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = '— ' + message;
    toast.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.style.display = 'none'; }, 1800);
  }
  window.__velaToast = showToast;

  // ── Sort menu (collection) ─────────────────────────────────
  function initSortMenu() {
    const btn = $('[data-sort-toggle]');
    const menu = $('[data-sort-menu]');
    const caret = btn ? $('.caret', btn) : null;
    if (!btn || !menu) return;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = menu.classList.toggle('cl-sort-menu-open');
      if (caret) caret.classList.toggle('caret-up', open);
    });
    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target) && !btn.contains(e.target)) {
        menu.classList.remove('cl-sort-menu-open');
        if (caret) caret.classList.remove('caret-up');
      }
    });
  }

  // ── Collection filters: auto-submit on toggle ──────────────
  function initCollectionFilters() {
    $$('[data-filter-form]').forEach(form => {
      form.addEventListener('change', () => form.submit());
    });
  }
})();
